// Simboli/regimi dietetici dei prodotti.
// Solo icone grafiche (nessun testo) — usate sia nella carta digitale (React)
// sia nella carta cartacea/PDF (stringa HTML), per garantire coerenza visiva.
import React from 'react';

// SVG "inner" (senza tag <svg>) per ogni tag. Il viewBox è sempre 0 0 24 24.
const ICON_INNER = {
  // Vegetariano: foglia singola
  vegetariano:
    '<path fill="none" stroke="#16a34a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"/>' +
    '<path fill="none" stroke="#16a34a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M2 21c0-3 1.85-5.36 5.08-6"/>',
  // Vegano: doppia foglia
  vegano:
    '<path fill="none" stroke="#15803d" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M2 2a26.6 26.6 0 0 1 10 20c.9-6.82 1.5-9.5 4-14"/>' +
    '<path fill="none" stroke="#15803d" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M16 8c4 0 6-2 6-6-4 0-6 2-6 6"/>',
  // Piccante: peperoncino
  piccante:
    '<path fill="#dc2626" d="M16 4c2.2 1 3 3.6 2.2 6.4C16.8 15.6 12 20 7 20c-1.7 0-2.9-1.1-2.9-2.6 0-1.1.9-1.8 1.9-1.8 3.6 0 6.6-2.7 7.6-6.1.4-1.4.2-2.9-.6-4z"/>' +
    '<path fill="none" stroke="#15803d" stroke-width="2" stroke-linecap="round" d="M16 4c-.3-1 .2-2.1 1.2-2.6.6-.3 1.3-.3 1.9 0"/>',
  // Senza glutine: spiga sbarrata
  senza_glutine:
    '<path fill="#b45309" d="M12 22a1 1 0 0 1-1-1v-8.9l-2.1 1.6a1 1 0 1 1-1.2-1.6L11 9.4V7.1L8.9 8.7A1 1 0 0 1 7.7 7.1L11 4.6V3a1 1 0 0 1 2 0v1.6l3.3 2.5a1 1 0 0 1-1.2 1.6L13 7.1v2.3l3.3 2.5a1 1 0 0 1-1.2 1.6L13 12.1V21a1 1 0 0 1-1 1z"/>' +
    '<path fill="none" stroke="#dc2626" stroke-width="2.4" stroke-linecap="round" d="M4 20 20 4"/>',
};

// Etichette IT (usate per tooltip/aria-label, NON mostrate come testo nelle carte).
export const DIET_TAG_META = {
  vegetariano: { key: 'vegetariano', label: 'Vegetariano', color: '#16a34a' },
  vegano: { key: 'vegano', label: 'Vegano', color: '#15803d' },
  piccante: { key: 'piccante', label: 'Piccante', color: '#dc2626' },
  senza_glutine: { key: 'senza_glutine', label: 'Senza glutine', color: '#b45309' },
};

// Ordine di visualizzazione stabile.
export const DIET_TAGS = ['vegetariano', 'vegano', 'piccante', 'senza_glutine'];

// Ritorna la stringa <svg> completa di un tag (per PDF/HTML string).
export const dietIconSvg = (key, size = 16) => {
  const inner = ICON_INNER[key];
  if (!inner) return '';
  const meta = DIET_TAG_META[key] || {};
  return (
    `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24" ` +
    `role="img" aria-label="${meta.label || key}" style="display:inline-block;vertical-align:middle;flex:0 0 auto;">` +
    `<title>${meta.label || key}</title>${inner}</svg>`
  );
};

// Ritorna un blocco HTML con tutte le icone dei tag passati (per PDF).
export const dietIconsHtml = (tags = [], size = 16, gapPx = 5) => {
  const valid = (tags || []).filter((k) => ICON_INNER[k]);
  if (!valid.length) return '';
  const icons = valid.map((k) => dietIconSvg(k, size)).join('');
  return `<span style="display:inline-flex;align-items:center;gap:${gapPx}px;vertical-align:middle;">${icons}</span>`;
};

// Componente React per la UI (carta digitale / editor).
export const DietIcons = ({ tags = [], size = 16, className = '' }) => {
  const valid = (tags || []).filter((k) => ICON_INNER[k]);
  if (!valid.length) return null;
  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`} data-testid="diet-icons">
      {valid.map((k) => (
        <span
          key={k}
          title={DIET_TAG_META[k]?.label || k}
          aria-label={DIET_TAG_META[k]?.label || k}
          style={{ lineHeight: 0 }}
          dangerouslySetInnerHTML={{ __html: dietIconSvg(k, size) }}
        />
      ))}
    </span>
  );
};
